import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CompanyAddressModel } from 'src/app/models/companyAddress/company-address-model';
import { ErrorMessageModel } from 'src/app/models/customer/customer.model';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { CompanyAddressService } from 'src/app/services/company-address.service';

@Component({
  selector: 'app-company-address-add',
  templateUrl: './company-address-add.component.html',
  styleUrls: ['./company-address-add.component.css']
})
export class CompanyAddressAddComponent implements OnInit {

  companyAddressModel: CompanyAddressModel = new CompanyAddressModel();
  Loader: boolean = false;
  errorMessageModel: Array<ErrorMessageModel> = new Array<ErrorMessageModel>();
  errorMessages: ErrorMessageModel = new ErrorMessageModel();

  constructor(private route:Router,private alertify: AlertifyService, private companyAdress: CompanyAddressService ) { }

  ngOnInit() {
  }
  
 CompanyAddress() {
  if (this.companyAddressModel.Title == undefined || this.companyAddressModel.Title == null || this.companyAddressModel.Title == "") {
    this.alertify.error("Title is required");
    return;
  }
  if (this.companyAddressModel.Name == undefined || this.companyAddressModel.Name == null || this.companyAddressModel.Name == "") {
    this.alertify.error("Name is required");
    return;
  }
  if (this.companyAddressModel.State == undefined || this.companyAddressModel.State == null || this.companyAddressModel.State == "") {
    this.alertify.error("State is required");
    return;
  }
  if (this.companyAddressModel.City == undefined || this.companyAddressModel.City == null || this.companyAddressModel.City == "") {
    this.alertify.error("City is required");
    return;
  }
  if (this.companyAddressModel.ZipCode == undefined || this.companyAddressModel.ZipCode == null || this.companyAddressModel.ZipCode == "") {
    this.alertify.error("ZipCode is required");
    return;
  }
  if (this.companyAddressModel.PhoneNumber == undefined || this.companyAddressModel.PhoneNumber == null || this.companyAddressModel.PhoneNumber == "") {
    this.alertify.error("Phone Number is required");
    return;
  }
  if (this.companyAddressModel.Country == undefined || this.companyAddressModel.Country == null || this.companyAddressModel.Country == "") {
    this.alertify.error("Country is required");
    return;
  }
  if (this.companyAddressModel.Email == undefined || this.companyAddressModel.Email == null || this.companyAddressModel.Email == "") {
    this.alertify.error("AddressNote is required");
    return;
  }
  this.companyAddressModel.ZipCode = this.companyAddressModel.ZipCode.toString();
  this.Loader = true;
  this.errorMessageModel = [];
  this.companyAdress.CompanyAddressAdd(this.companyAddressModel)
  .subscribe(response => {
    var responseBody = JSON.parse(response._body);
    if (responseBody.isSuccess) {
      this.alertify.success(responseBody.responseMessage);
      this.route.navigate(['/company-address-listing']);
      this.Loader = false;
    } else {
      for(var i = 0; i < responseBody.responseData.messages.length; i++) {
        this.errorMessages = responseBody.responseData.messages[i];
        var messagesItem = new ErrorMessageModel();
        if (this.errorMessages) {
          messagesItem = this.errorMessages;
          this.errorMessageModel.push(messagesItem);
        }
        this.Loader = false;
    }
    }
  })
}
}
